/**
 * This function gets called as part of the check for whether to load
 * revolutionSlider or not.
 *
 * @returns {boolean}
 */
function revolutionSliderTest(){
  return (document.querySelectorAll('[data-plugin-revolution-slider]:not(.manual), .slider-container .slider:not(.manual), #revolutionSlider').length > 0)
}

/**
 * This function is called to allow clients to add more components if needed
 *
 * @param {object} context - contains the current Vue instance and Store
 * @param {int} position - where in the call process you are
 */
function extraComponents({Vue, store, inits,}, position){
  return void(0);
}


export default {
  revolutionSliderTest,
  extraComponents,
}


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/utils/mainOverrides.js